export enum ReporteType{
    VENTAS ="ventas",
    VENTAS_DETALLADAS = "ventas_detalladas",
    VENTAS_PERIODO ="ventas_periodo",
    PRODUCTOS_PERIODO="productos_periodo",
    CATALOGO_PERIODO ="catalogo_periodo"
}